// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__igHx_","Success":"Button_Success__3qesX","Help":"Button_Help__2_q82","Danger":"Button_Danger__3ssRN"};